export default "__VITE_ASSET__DCMGemUW__"